module.exports = __webpack_public_path__ + "img/contact_protocal.20db81b6.png";